<template>
  <svg
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M17.6087 2.72661H15.5217L14.3696 1.02248C13.9348 0.38343 13.1739 0 12.3913 0H7.6087C6.82609 0 6.06522 0.38343 5.63043 1.02248L4.47826 2.72661H2.3913C1.06522 2.72661 0 3.77039 0 5.06979V13.3348C0 14.6342 1.06522 15.678 2.3913 15.678H17.6087C18.9348 15.678 20 14.6342 20 13.3348V5.06979C20 3.77039 18.9348 2.72661 17.6087 2.72661ZM10 13.7609C7.02174 13.7609 4.6087 11.3964 4.6087 8.47806C4.6087 5.55973 7.02174 3.21655 10 3.21655C12.9783 3.21655 15.3913 5.58103 15.3913 8.49936C15.3913 11.3964 12.9783 13.7609 10 13.7609ZM17.3043 6.02837C17.2826 6.02837 17.2609 6.02837 17.2174 6.02837H16.3478C15.9565 6.00707 15.6522 5.68754 15.6739 5.30411C15.6957 4.94198 15.9783 4.66506 16.3478 4.64376H17.2174C17.6087 4.62246 17.9348 4.92068 17.9565 5.30411C17.9783 5.68754 17.6957 6.00707 17.3043 6.02837Z"
          fill="white"
    />
    <path d="M10 5.55957C8.34783 5.55957 7 6.88027 7 8.4992C7 10.1181 8.34783 11.4175 10 11.4175C11.6522 11.4175 13 10.0968 13 8.4779C13 6.85897 11.6522 5.55957 10 5.55957Z"
          fill="white"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconQRScan'
}
</script>